module.exports = __webpack_public_path__ + "static/media/explication-roadbook-NARE.0e81ac02.pdf";